<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/welcome' }">基础信息管理</el-breadcrumb-item>
      <el-breadcrumb-item>消息通知管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="是否已读：">
        <el-select v-model="formInline.isRead" filterable>
          <el-option label="全部" value=""></el-option>
          <el-option label="未读" value="0"></el-option>
          <el-option label="已读" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="内容：">
        <el-input size="small" v-model="formInline.content" placeholder="支持消息内容模糊查询" clearable/>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="commonMsgData" highlight-current-row v-loading="loading" border
              element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column prop="gmtCreate" label="发送时间" width="160"/>
      <el-table-column prop="sourceUserName" label="发送人" show-overflow-tooltip width="160"/>
      <el-table-column prop="actionName" label="消息类型" width="120"/>
      <el-table-column prop="content" label="消息内容" show-overflow-tooltip/>
      <el-table-column align="center" prop="isRead" label="是否已读" :formatter="readFormatter" width="100"/>
      <el-table-column align="center"prop="readTime" label="阅读时间" width="160"/>
      <el-table-column align="center" label="操作" width="100">
        <template slot-scope="scope">
          <el-button size="mini" type="success" v-if="scope.row.isRead != 1" @click="read(scope.$index, scope.row)">已读</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageParam" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
// 导入请求方法
import {queryByPageByAdmin, read} from '../../api/commonMsgMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      commonMsgData: [],  //消息通知数据
      loading: false, //是显示加载
      // 请求数据参数
      formInline: {
        page: 1,
        limit: 20,
        isRead: '0',
        content: ''
      }, UserDept: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      // 分页参数
      pageParam: {
        currentPage: 1,
        pageSize: 20,
        total: 20
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */
  watch: {},
  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取数据方法
    getdata(parameter) {
      this.loading = true
      this.loading = false
      queryByPageByAdmin(parameter).then(res => {
        this.loading = false
        if (res.code != 0) {
          this.$message({type: 'info', message: res.msg})
        } else {
          this.commonMsgData = res.data.list
          // 分页赋值
          this.pageParam.currentPage = res.data.page
          this.pageParam.pageSize = res.data.limit
          this.pageParam.total = res.data.total
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    //搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //阅读
    read(index, row) {
      let id = row.id;
      this.$confirm('确认已接收到信息并已阅读?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        read(id).then(res => {
          if (res.code == 0) {
            this.$message({type: 'success', message: '阅读成功!'})
            this.getdata(this.formInline)
          } else {
            this.$message({type: 'info', message: res.msg})
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('操作失败，请稍后再试！')
        })
      }).catch(() => {
        this.$message({type: 'info', message: '已取消此操作！'})
      })
    },
    //阅读状态格式化
    readFormatter: function (row, column) {
      return row.isRead == 1 ? '已读' : '未读';
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/commonMsg/commonMsg.vue